import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { ApiService } from '../../../Services/api.service';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { isBoolean } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-edit-price-detail',
  standalone: true,
  imports: [CommonModule, NzCollapseModule, NzIconModule, NzButtonModule, NzSelectModule, FormsModule, NzSwitchModule],
  templateUrl: './add-edit-price-detail.component.html',
  styleUrl: './add-edit-price-detail.component.scss'
})
export class AddEditPriceDetailComponent {
  constructor(private apiService: ApiService) {

  }

  selectedEdpAr: string = '';
  edpArList: any = [];
  lotList: any = [];
  invalidForm: boolean = false;
  priceDisplayList: any = [
    { id: 1, fieldName: "EDP/AR #", fieldType: "select", placeholder: "Select EDP/AR #", value: '' },
    { id: 2, fieldName: "Lot Id", fieldType: "select", placeholder: "Select Lot Id", value: [], lotList: [] },
    { id: 3, fieldName: "Same Price for all Sizes", fieldType: "toggle", value: false },
    { id: 4, fieldName: "Clear", fieldType: "button", value: '', actionIds: [1, 2, 3] }
  ];
  @Input() programList: any = [];
  repeatedLocation: boolean = false;
  @Output() emitData = new EventEmitter();
  selectedPairs: any = [];
  lotSearchSubscription?: Subscription;
  @ViewChildren('ARSelect') arEdpComponents!: QueryList<NzSelectComponent>;

  focusFirstSelect(): void {

    if (this.arEdpComponents && this.arEdpComponents.first) {
      this.arEdpComponents.first.focus();
    }
  }

  ngAfterViewInit() {
    this.focusFirstSelect();
  }

  getEdpArNoList(event: string) {

    const inputLength = event ? event.trim().length : 0;

    if (inputLength === 5 || inputLength === 11) {
      this.apiService.getEdpArNoLists(event).subscribe(res => {
        if (res && res.data) {
          this.edpArList = res.data;
        } else {
          this.edpArList = [];
        }
      });
    } else {
      this.edpArList = [];
    }
  }

  getLotList(event: string, index: number) {
    const query = event?.toUpperCase().trim();
    if (!query) return;

    const currentRow = this.priceDisplayList[index];
    if (!currentRow) return;

    if (this.lotSearchSubscription) {
      this.lotSearchSubscription.unsubscribe();
    }

    this.lotSearchSubscription = this.apiService.getLotList(query).subscribe({
      next: (res) => {
        currentRow.lotList = res.map((node: any) => ({
          ...node,
          disabled: false
        }));

        // Apply the global duplicate filter checks
        this.applyDisabledState(index);
      }
    });
  }

  applyDisabledState(currentIndex: number) {
    const currentRow = this.priceDisplayList[currentIndex];


    if (!currentRow || !currentRow.lotList) {
      return;
    }


    const currentBlockIndex = Math.floor(currentIndex / 4);


    const lotsTakenByOtherRows = new Set<string>();
    const totalRows = this.priceDisplayList.length / 4;

    for (let i = 0; i < totalRows; i++) {
   
      if (i === currentBlockIndex) continue;

      const lotElementIndex = (i * 4) + 1; 
      const otherRowSelectedLots = this.priceDisplayList[lotElementIndex]?.value;

      if (Array.isArray(otherRowSelectedLots)) {
        otherRowSelectedLots.forEach((lotNo: string) => {
          lotsTakenByOtherRows.add(lotNo);
        });
      }
    }

   
    currentRow.lotList = currentRow.lotList.map((node: any) => ({
      ...node,
      disabled: lotsTakenByOtherRows.has(node.lotNo)
    }));
  }

  handleOpenChange(isOpen: boolean, index: number) {
    const currentRow = this.priceDisplayList[index];

    if (isOpen && currentRow) {
      if (!currentRow.lotList) {
        currentRow.lotList = [];
      }


      this.applyDisabledState(index);
    }
  }

  onlyNumberKey(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }
  onlyAlphanumeric(event: KeyboardEvent) {
    const key = event.key;

    const isControlKey = [
      'Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ].includes(key);

    if (isControlKey) {
      return;
    }

    const isAlphanumeric = /^[a-zA-Z0-9]$/.test(key);

    if (!isAlphanumeric) {
      event.preventDefault();
    }
  }



  clearRow(data: any) {
    this.edpArList = [];
    this.lotList = [];
    this.priceDisplayList.map((res: any, i: any) => {
      if (data.actionIds.includes(res.id)) {

        if (Array.isArray(res.value) && res.value.length > 0) {
          const JobCodeSet = new Set(res.value.map((node: any) => node.lotNo));
          this.selectedPairs.forEach((node: any) => {
            if (node.EDPARValue === this.priceDisplayList[i - 1].value) {
              node.mappedLots = node.mappedLots.filter((child: any) =>
                !JobCodeSet.has(child)
              );
            }
          });
          res.value = [];
          this.priceDisplayList[i - 1].value = '';
          res.jobCodeList = [];
        }
        else if (isBoolean(res.value)) {
          res.value = false;

        }
      }
    })
  }

  isLastRow(index: number): boolean {

    return index >= this.priceDisplayList.length - 4;
  }

  addRow() {
    this.edpArList = [];
    this.lotList = [];
    const lastEdpEntry = [...this.priceDisplayList]
      .reverse()
      .find(item => item.placeholder === "Select EDP/AR #");

    const lastId = this.priceDisplayList.length > 0
      ? this.priceDisplayList[this.priceDisplayList.length - 1].id
      : 0;

    this.priceDisplayList.push(
      {
        id: lastId + 1,
        fieldName: "",
        fieldType: "select",
        placeholder: "Select EDP/AR #",
        value: ''
      },
      { id: lastId + 2, fieldName: "", fieldType: "select", placeholder: "Select Lot Id", value: [], jobCodeList: [] },
      { id: lastId + 3, fieldName: "", fieldType: "toggle", value: false },
      {
        id: lastId + 4,
        fieldName: "Clear",
        fieldType: "button",
        value: '',
        placeholder: "",
        actionIds: [lastId + 1, lastId + 2, lastId + 3]
      }
    );
  }

  handleTabOut(event: KeyboardEvent, currentPanel: any): void {
    // 1. Find all "Select Lot #" panels to figure out which row we are on contextually
    const lotPanels = this.priceDisplayList.filter((p: any) => p.placeholder === 'Select Id');
    const currentRowIndex = lotPanels.findIndex((p: any) => p.id === currentPanel.id);

    // 2. Prevent default browser focus jumping so we can control it safely
    event.preventDefault();

    // 3. Check if this is the absolute last row in the list
    if (currentRowIndex === lotPanels.length - 1) {
      // It's the last row! Add a new row block
      this.addRow();

      // Wait a split second for Angular to render the new row, then focus it
      setTimeout(() => {
        this.focusArEdpAt(currentRowIndex + 1);
      }, 50);
    } else {
      // It's an earlier row! Just jump straight down to the next existing row's AR/EDP
      this.focusArEdpAt(currentRowIndex + 1);
    }
  }

  // Safe helper to target specific array indexes
  focusArEdpAt(index: number): void {
    if (this.arEdpComponents) {
      const selectArray = this.arEdpComponents.toArray();
      if (selectArray[index]) {
        selectArray[index].focus();
      }
    }
  }

validateForm() {
  const totalRows = this.priceDisplayList.length / 4;
  let validRowsData: any[] = [];
  let totalValidEdpCount = 0;
  let hasRowLevelErrors = false;

  for (let i = 0; i < totalRows; i++) {
    const startIndex = i * 4;
    
    const edpItem = this.priceDisplayList[startIndex];      // Element 1: EDP/AR #
    const lotItem = this.priceDisplayList[startIndex + 1];  // Element 2: Lot Id
    const toggleItem = this.priceDisplayList[startIndex + 2]; // Element 3: Toggle
    const buttonItem = this.priceDisplayList[startIndex + 3]; // Element 4: Clear Button

    const edpVal = edpItem?.value;
    const isEdpPopulated = typeof edpVal === 'string' ? edpVal.trim().length > 0 : !!edpVal;
    
    const lotVal = lotItem?.value;
    const isLotPopulated = Array.isArray(lotVal) ? lotVal.length > 0 : !!lotVal;

    // Localized check: If Lot is selected, EDP is required for THIS specific row
    if (isLotPopulated && !isEdpPopulated) {
      edpItem.edpMissing = true;
      hasRowLevelErrors = true;
    } else {
      edpItem.edpMissing = false;
    }

    // If this row has a valid EDP and no individual errors, it's eligible to save
    if (isEdpPopulated && !edpItem.edpMissing) {
      totalValidEdpCount++;
      validRowsData.push(edpItem, lotItem, toggleItem, buttonItem);
    }
  }

  // CRITICAL CHANGE: The entire form is only globally invalid if NOT A SINGLE row has a valid EDP
  this.invalidForm = totalValidEdpCount === 0;

  // If the form has a valid row to save, return it; otherwise return an empty array
  return this.invalidForm ? [] : validRowsData;
}

resetValidationState() {
  const totalRows = this.priceDisplayList.length / 4;
  let totalValidEdpCount = 0;

  for (let i = 0; i < totalRows; i++) {
    const startIndex = i * 4;
    const edpItem = this.priceDisplayList[startIndex];
    const lotItem = this.priceDisplayList[startIndex + 1];

    const edpVal = edpItem?.value;
    const lotVal = lotItem?.value;

    const isEdpPopulated = typeof edpVal === 'string' ? edpVal.trim().length > 0 : !!edpVal;
    const isLotPopulated = Array.isArray(lotVal) ? lotVal.length > 0 : !!lotVal;

    // Adjust row-level warning markers
    if (isLotPopulated && !isEdpPopulated) {
      edpItem.edpMissing = true;
    } else {
      edpItem.edpMissing = false;
    }

    if (isEdpPopulated && !edpItem.edpMissing) {
      totalValidEdpCount++;
    }
  }

  // Global form error is active ONLY if no valid rows are present across the form
  this.invalidForm = totalValidEdpCount === 0;
}

  onEdpUpdate(value: any, index: number) {
    this.resetValidationState();
  }

  onLotUpdate(value: any, index: number) {
    this.resetValidationState();
  }

  saveRow() {
    // 1. Run the validation which determines row-by-row correctness
    const validDataChunks = this.validateForm();

    // 2. Instead of checking arbitrary array lengths, check the explicit validity flag
    if (!this.invalidForm && validDataChunks.length > 0) {

      // 3. Generate your payload using the clean data chunks
      const data = this.createPriceDisplayPayload(validDataChunks);

      if (data && data.length > 0) {
        this.emitData.emit(data);
      } else {
        console.warn("Validation passed, but payload creation returned empty data.");
      }
    } else {
      // Flag form as invalid to highlight errors in the UI
      this.invalidForm = true;
    }
  }

resetForm() {
  this.edpArList = [];
  this.lotList = [];

  this.priceDisplayList.forEach((res: any) => {
   
    if (res && res.value !== undefined && res.value !== null) {
      
      if (typeof res.value === 'string') {
        res.value = '';
      } 
      else if (typeof res.value === 'boolean') { 
        res.value = false;
      } 
      else if (Array.isArray(res.value)) { 
        res.value = [];
      }
      
    }
  });
}

  closeSelect(selectComponent: NzSelectComponent, evt: any, index: number) {
    selectComponent.nzOpen = false;
  }

  createPriceDisplayPayload(data: any) {
    const addPayLoad: any = [];

    // Since each row consists of exactly 4 elements (EDP, Lot, Toggle, Button),
    // we increment our loop step by 4 to cleanly process row by row.
    for (let i = 0; i < data.length; i += 4) {
      const current = data[i];       // EDP/AR #
      const next = data[i + 1];     // Lot Id
      const toggle = data[i + 2];   // Toggle

      // Ensure we have at least the EDP element populated
      if (current && current.value) {
        const edpNoValue = current.value;
        const samePriceValue = toggle && toggle.fieldType === 'toggle' ? (toggle.value ? 1 : 0) : 0;

        const hasLots = next && Array.isArray(next.value) && next.value.length > 0;

        if (hasLots) {
          // Scenario A: If lots are selected, create an entry for each lot
          next.value.forEach((lot: any) => {
            addPayLoad.push({
              edpNo: edpNoValue,
              lotId: [lot],
              samePriceForAllSkus: samePriceValue,
              updateType: 'ADD'
            });
          });
        } else {
          // Scenario B: EDP is entered, but NO lots are selected. 
          // We still save the row with an empty or null lot tracking payload.
          addPayLoad.push({
            edpNo: edpNoValue,
            lotId: [], // or null, depending on what your API backend expects for no-lot submissions
            samePriceForAllSkus: samePriceValue,
            updateType: 'ADD'
          });
        }
      }
    }

    return addPayLoad;
  }

  pushPairs(evt: any[], j: number) {
    const currentEDPAR = this.priceDisplayList[j - 1].value;
    const allLotsForThisEDP = this.priceDisplayList
      .filter((item: any, index: any) =>
        item.fieldName === "Lot Id" &&
        this.priceDisplayList[index - 1].value === currentEDPAR
      )
      .flatMap((item: any) => item.value || []);

    const pairIndex = this.selectedPairs.findIndex((p: any) => p.EDPARValue === currentEDPAR);

    const uniqueLots = [...new Set(allLotsForThisEDP)];

    if (pairIndex !== -1) {
      this.selectedPairs[pairIndex].mappedLots = uniqueLots;
    } else {
      this.selectedPairs.push({
        "EDPARValue": currentEDPAR,
        "mappedLots": uniqueLots
      });
    }

    this.priceDisplayList.forEach((item: any, index: any) => {
      if (item.fieldName === "Lot Id") {
        this.applyDisabledState(index);
      }
    });
  }

}
